import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Container from "react-bootstrap/Container";
import { Card, Col, Row } from "react-bootstrap";
import Cards from "./../../components/Cards/Cards";
import { Link } from "react-router-dom";
import { GetCustomerDashboard } from "../../apis/DashboardAPI";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesDefaultsItemTooltip,
  ChartSeriesItem,
  ChartTooltip,
} from "@progress/kendo-react-charts";
import { GetNotifications } from "../../apis/NotificationAPI";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Dashboard() {
  const { user } = useSelector((state) => state.auth);
  const [newCount, setNewCount] = useState(0);
  const [prelimCount, setPrelimCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [progressCount, setProgressCount] = useState(0);
  const [notificationList, setNotificationList] = useState([]);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data.slice(0, 4));
  }

  useEffect(() => {
    async function GetOrderData() {
      var result = await GetCustomerDashboard(user.requestorid);
      var data = result.data;
      setNewCount(data.filter((d) => d.order_status_id === 1)[0].order_count);
      setPrelimCount(
        data.filter((d) => d.order_status_id === 7)[0].order_count
      );
      setCompletedCount(
        data.filter((d) => d.order_status_id === 3)[0].order_count
      );
      setProgressCount(
        data.filter((d) => d.order_status_id === 6)[0].order_count
      );
    }
    GetOrderData();
    GetUserNotifications();
  }, []);

  const series = [
    { category: "New orders", value: newCount },
    { category: "Orders in progress", value: progressCount },
  ];

  window.addEventListener("notification", () => {
    GetUserNotifications();
  });

  return (
    <>
      <Container className="customer-dashboard">
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Dashboard</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}></Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="cards-row">
              <div className="cards-col">
                <div className="dashboard-link">
                  <Link to="/customer/submitorder">Order Now</Link>
                  <Link to="/customer/CreditApplicationForm">
                    Send Credit Application
                  </Link>
                  <Link to="/customer/Invoices">View Invoices</Link>
                </div>
              </div>
              <div className="cards-col">
                <Cards
                  newCount={newCount}
                  prelimCount={prelimCount}
                  completedCount={completedCount}
                  orderLink="/Customer/Orders"
                />
              </div>
              <div className="cards-col">
                <Card>
                  <Card.Body>
                    <Chart>
                      <ChartLegend position="bottom" />
                      <ChartTooltip visible={true} />
                      <ChartSeries>
                        <ChartSeriesItem
                          type="pie"
                          data={series}
                          field="value"
                          categoryField="category"
                        >
                          <ChartSeriesDefaultsItemTooltip format="{0}" />
                        </ChartSeriesItem>
                      </ChartSeries>
                    </Chart>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="my-5">
          <Col lg={12}>
            <Card className="notifications-card">
              <div className="card-head">
                <div className="card-title h5">Notifications</div>
              </div>
              <ul className="notifications-list max-no-list">
                {notificationList.map((item) =>
                  item.order_status_name === "Completed" ? (
                    <li
                      className={item.view_id === 0 ? "unread" : ""}
                      key={item.order_id}
                    >
                      <p>
                        Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        for {item.applicant_name} was marked completed.{" "}
                        {item.template_name != null && (
                          <Link
                            to={`/Report?type=view&id=${item.order_report_mapping_id}`}
                            target="_blank"
                            className={
                              item.template_name.includes("Pdf Reports")
                                ? "no-display"
                                : ""
                            }
                          >
                            View Reports
                          </Link>
                        )}
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "In Progress" ? (
                    <li
                      className={item.view_id === 0 ? "unread" : ""}
                      key={item.order_id}
                    >
                      <p>
                        Work started on Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        for {item.applicant_name}.
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "Preliminary" ? (
                    <li
                      className={item.view_id === 0 ? "unread" : ""}
                      key={item.order_id}
                    >
                      <p>
                        Preliminary report generated of Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        for {item.applicant_name}.{" "}
                        <Link
                          to={`/Report?type=view&id=${item.order_report_mapping_id}`}
                          target="_blank"
                          className={
                            item.template_name.includes("Pdf Reports")
                              ? "no-display"
                              : ""
                          }
                        >
                          View Reports
                        </Link>
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "Received" ? (
                    <li
                      className={item.view_id === 0 ? "unread" : ""}
                      key={item.order_id}
                    >
                      <p>
                        Form number{" "}
                        <Link
                          to={`/Form?token=view&id=${item.form_template_id}&applicationid=${item.order_id}`}
                          target="_blank"
                        >
                          {item.form_number}
                        </Link>{" "}
                        has been received from {item.applicant_name}.{" "}
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "Invoiced" ? (
                    <li
                      className={item.view_id === 0 ? "unread" : ""}
                      key={item.order_id}
                    >
                      <p>
                        Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        has been invoiced.{" "}
                        <Link
                          to={`/Invoice?customerid=${user.customerid}&invoiceid=${item.invoice_id}`}
                          target="_blank"
                        >
                          View Invoice
                        </Link>
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
              <Card.Link href="/Customer/Notifications">View All</Card.Link>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
